export const PAGE_CONFIG = {
  name: 'CommonPermissionWrap',
  children: [
    {
      name: 'CommonLogWrap',
      config: {
        logConfig: {
          pageId: '911001',
          pageName: 'creativeTrends',
          extInfo: 'home-studio-creativeTrends',
          pagePath: '/creativeTrends',
        },
      },
      children: [
        {
          name: 'CreativeTrendsWrapper',
          config: {
            componentName: 'CreativeTrends',
            prNoticeMarquee: {
              textEn: '',
              textZh: '',
            },
            componentProps: {
              hidePageHeader: true,
              hideGameCategoryTabs: true,
              enableSourcePageLog: false,
              filterInstanceId: 'studio-creative-trends',
              defaultFilter: {
                game_category: 'Arrows-like',
              },
            },
          },
        },
      ],
    },
  ],
};
